export const userTableTamplate = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 60,
  },
  {
    id: 'username',
    description: 'Nome de usuário',
    originalId: 'username',
    width: 150,
  },
  {
    id: 'name',
    description: 'Nome',
    originalId: 'name',
    width: 250,
  },
  {
    id: 'document_number',
    description: 'CPF',
    originalId: 'document_number',
    width: 150,
  },
  {
    id: 'rg',
    description: 'RG',
    originalId: 'rg',
    width: 120,
  },
  {
    id: 'email',
    description: 'E-mail',
    originalId: 'email',
    width: 300,
  },
  {
    id: 'phone',
    description: 'Telefone',
    originalId: 'phone',
    width: 130,
  },
  {
    id: 'formattedProfileName',
    description: 'Perfil',
    originalId: 'formattedProfileName',
    width: 120,
  },
  {
    id: 'formattedActive',
    description: 'Ativo',
    originalId: 'formattedActive',
    width: 200,
  },
];
